<script lang="ts">
  import { Image } from "sveltestrap";
  let imgPath:string = "/assets/images/user"
  export let customerItem
</script>
<div class="customers">
    <ul>
        {#each customerItem.imgdata as imgItem}
            <li class="d-inline-block">
                <Image class="img-30 rounded-circle" src="{imgPath}/{imgItem.img}" />
            </li>
        {/each}
        <li class="d-inline-block ms-2">
            <p class="f-12">{customerItem.customers}</p>
        </li>
    </ul>
</div>